import { Pipe, PipeTransform } from '@angular/core';
import moment from "moment";
import { Moment } from "moment";

@Pipe({
    name: 'transformDate'
})
export class TransformDatePipe implements PipeTransform {
    transform(date: string): string {
        const dateMoment: Moment = moment(date, 'YYYY-MM-DD').locale('fr');
        return dateMoment.format('dddd DD MMMM');
    }
}
